// Plays `audio` from the start. Resolves to true once playback has started and
// false otherwise, so callers can react only to a real play. AbortError (the
// play was interrupted by pause() or the element unmounting) is ignored; any
// other failure is logged and passed to `onError`.
export const playAudio = (audio, onError) => {
  if (!audio) {
    if (onError) onError(new Error("Audio element is not available."));
    return Promise.resolve(false);
  }

  try {
    audio.currentTime = 0;
  } catch (e) {
    // ignore – some browsers throw before metadata is loaded
  }

  const playPromise = audio.play();
  if (!playPromise || typeof playPromise.then !== "function") {
    return Promise.resolve(true);
  }

  return playPromise
    .then(() => true)
    .catch((error) => {
      if (error && error.name === "AbortError") {
        return false;
      }
      console.error("Audio playback failed:", error);
      if (onError) onError(error);
      return false;
    });
};

// Pauses every <audio> on the page except `keep`.
export const pauseOtherAudio = (keep) => {
  document.querySelectorAll("audio").forEach((el) => {
    if (el !== keep) el.pause();
  });
};
